import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as action from '../../store/actions/profileActions';
import '../../assets/css/style.css';

const ProfileName = () => {
    const profile = useSelector(state => state.profile.profile);
    const dispatch = useDispatch();
    
    const handleChange = (e) => {
        dispatch(action.collectProfileData({...profile, profileName: e.target.value}));
    }

    return (
        <div className="uni-form">
            <input className="uni-text" value={profile.profileName} onChange={handleChange} type="text" id="name" placeholder="name" required />
            <h6 className="field-warning">Keep in mind that you won't be able to change or edit your name</h6>
        </div>
    );
};

export default ProfileName;